

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { gotoDetail } from '@core/utils/index'

@Component({})
export default class PromotionGroupItem extends Vue {
  @Prop({ default: () => {} }) readonly group!: any

  money(price: number) {
    const _price = (price / 100).toFixed(1)
    let splitPrice = _price.toString().split('.')
    return `${splitPrice[0]}.<span style="font-size:0.32rem;font-weight: 500;">${splitPrice[1]}</span>`
  }

  toDetail() {
    const { businessId, templateType2Id: spuType, spuId = '', skuId = '', promotionId: ruleId = '', promotionType: ruleType = '' } = this.group
    gotoDetail({ businessId, spuType, spuId, skuId, ruleId, ruleType, module: 6 })
  }
}
